import { render, staticRenderFns } from "./publish.vue?vue&type=template&id=340e0326&scoped=true"
import script from "./publish.vue?vue&type=script&lang=js"
export * from "./publish.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340e0326",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('340e0326')) {
      api.createRecord('340e0326', component.options)
    } else {
      api.reload('340e0326', component.options)
    }
    module.hot.accept("./publish.vue?vue&type=template&id=340e0326&scoped=true", function () {
      api.rerender('340e0326', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/protocolCompliance/protocolManage/components/publish.vue"
export default component.exports